export default {
	'add-visit': 'Add visit',
	'edit-visit': 'Edit visit',
	'visit-is-created': 'Visit is created',
	'visit-is-updated': 'Visit is updated',
	'visit-is-queued': 'Visit saved - will sync automatically once you\'re back online',
	'sending-visit': 'Sending the visit now...',
	'no-invoice-to-pay': 'This visit has no invoice, so no payment method is needed',
	'the-visit': 'the visit',
	'daily-report': 'Daily Report',
	'report-type': {
		important: 'Important',
		complaint: 'Complaint',
		'normal-note': 'Normal note',
	},
	'daily-report-is-updated': 'Daily report is updated',
	'no-visits-to-show': 'NO VISITS TO SHOW',
	'visit-details': 'Visit details',
	'customer-details': 'Customer details',
	'new-customer': 'New customer',
	total: 'Total',
	remaining: 'Remaining',
	'insufficient-material-balance': 'You cannot add this material, you do not have enough balance of it',
	'amount-exceeds-remaining': 'Amount cannot exceed the remaining balance ({limit})',
	'available-pieces': 'Only {count} pieces available',
	'deliver-material': 'Deliver another material',

	'balance-update': 'Balance update',
	'balance-update-error': 'Something goes wrong on updating balance, please click "update" to update the balance',

	'tab-scientific': 'Scientific',
	'tab-commercial': 'Commercial',
	'tab-marketing': 'Marketing',
	'create-order': 'Create order',
	'order-items': 'Order items',
	order: 'Order',
	'order-id': 'Order ID',
	'order-details': 'Order details',
	'no-order-items': 'No order items',
	'order-delivery-date-without-items': 'Please add order items or clear the delivery info to save.',
	'add-plan-materials': 'Add plan materials',
	'remove-plan-materials': 'Remove plan materials',

	'view-last-visit': 'View last visit',
	'no-last-visit': 'No previous visit found',
	'no-samples-delivered': 'No samples delivered',
	'view-invoice': 'View Invoice',
	debtor: 'Debtor',
	'tab-invoice': 'Invoice',
	'tab-return': 'Return',
	'quantity-packages': 'Qty (pkgs)',
	'materials-total': 'Materials total',
	'returns-total': 'Total return amount',
	'final-total': 'Final total',
	discount: 'Discount',
	'discount-amount': 'Discount amount (if any)',
	'payment-details': 'Payment details',
	'add-payment-method': 'Add another payment method',
	'confirm-and-save': 'Confirm and save',
	'receive-material': 'Receive another material',
	'request-material': 'Request another material',
	'scan-qr': 'Scan customer QR',
	'qr-applied': 'Customer selected from QR code',
	'qr-invalid': 'This QR code could not be read',
	'qr-customer-not-found': 'No customer matches this QR code',
	'qr-camera-error': 'Unable to access the camera',

	'return-reasons': {
		ravages: 'Damaged',
		stocktaking: 'Stocktaking',
		undefined: 'Other',
	},
}